'use strict';

var $           = require('jquery');
var Backbone    = require('backbone');
var _           = require('lodash');

module.exports = Backbone.Model.extend({
    apiUrl: "https://secureapi-cloud.votenow.tv/moderation/getMessages",
    tempItems: {},
    defaults: {
        messages: []
    },

    options: {
        topic_id: null,
        offset: null,
        position: null,
        contains: "", //Comma delimited.  Uses OR operator.
        notContains: "", //Comma delimited.  Users OR operator.
        isVerified: 'false', //Set to true to only return Twitter verified users
        userScore: "", //Comma delimited userScore range.
        length: "", //Comma delimited message length range.

        keyword: "", //Alpha-numeric string of keywords. Comma delimited.
        include: 'true', //true: include keywords, false: exclude keywords.

        country: null, //Filter by country code.  Only one allowed.

        state: "", //Filter by state.  Only one allowed.

        includeComments: 'true', //Set to `false` to do not include post comments added in Connect Moderation
    },

    initialize: function(attrs, options) {
        _.extend(this.options, options);

        this.apiUrl = options.apiUrl? options.apiUrl : this.apiUrl;
    },

    /**
     *
     */
    destroy: function(options) {
        console.warn('The Moderation model does not support "destroy"');
    },
    /**
     *
     */
    save: function(options) {
        console.warn('The Moderation model does not support "save"');
    },

    // Prepare the url for AJAX REQUEST
    // - request number of items base on setting
    // - take the last position of social moderation item
    urlRoot: function () {
        return this.apiUrl;
    },

    /**
     * [connect description]
     * @param  {[type]} attr [description]
     * @return {[type]}      [description]
     */
    connect: function (attr) {
        this.fetch(attr);
    },

    fetch: function(options) {
        options = _.extend({ data: this.options }, options);

		if (options.data.folder) {
			options.data['topic_id'] = options.data['topic_id'] + ':' + options.data.folder;
		}

        console.log(options);
        return Backbone.Model.prototype.fetch.call(this, options);
    },

    parse: function(response) {
        var ret = [];

        _.each(response, function(message, key) {
            ret[key] = message;
        });

        return { messages: ret };
    }
});
